'use strict';

module.exports = string => {
    /*Mobile menu bahavior*/
    const $menu = $('.header__menu');
    let $menuBtn = $('.header__menu-burger');
    let $menuItems = $('.header__menu .menu-item');
    let $body = $('body');
    let $overlay = $('.menu-overlay');

    $menuBtn.on('click', function (e) {
        e.preventDefault();


        if ($(window).width() <= 1200) {
            this.classList.toggle('close');
            $overlay.toggleClass('active');
            $menu.toggleClass('active');
            $body.toggleClass('menu-open');

        }
    });
    $menuItems.on('click', function () {
        if ($(window).width() <= 1200) {
            $menu.removeClass('active');
            $menuBtn.removeClass('close');
            $body.removeClass('menu-open');
            $overlay.removeClass('active');
        }
    });

    $(window).on('resize', function () {
        $menu.removeClass('active');
        $menuBtn.removeClass('close');
        $body.removeClass('menu-open');
    });

    const header = document.querySelector('.header__wrapper');

}